import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { endpoints } from '../api/api';
import '../styles/ReservationSection.css';

const ReservationSection = ({ isMobile }) => {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [subscriberCount, setSubscriberCount] = useState(1000);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  
  // 根据当前语言决定显示th还是位
  const getNumberSuffix = () => {
    return i18n.language === 'zh' ? '位' : <sup>th</sup>;
  };
  
  useEffect(() => {
    // 在组件挂载时获取当前订阅用户数
    fetchSubscriberCount();
  }, []);

  const fetchSubscriberCount = async () => {
    try {
      const response = await endpoints.subscriptions.getCount();
      if (response.data && response.data.count) {
        setSubscriberCount(response.data.count);
      }
    } catch (err) {
      console.error('Failed to fetch subscriber count:', err);
    }
  };
  
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 清除之前的消息
    setMessage('');
    setError('');
    
    // 验证邮箱
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }
    
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await endpoints.subscriptions.create({
        email: email.trim()
      });
      
      if (response.data.success) {
        setMessage(response.data.message || 'Thank you for your reservation! We will notify you when BOBO is ready.');
        if (response.data.subscriberCount) {
          setSubscriberCount(response.data.subscriberCount);
        }
        setEmail(''); // 清空输入框
      }
    } catch (err) {
      console.error('Submit email failed:', err);
      setError(err.response?.data?.message || 'Submit failed, please try again later');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // 获取等候者标题文本（前半部分）
  const getWaitlisterTitleText = () => {
    return i18n.language === 'zh' 
      ? "你将成为BOBO第" 
      : "You will be the";
  };

  // 获取等候者标题文本（后半部分）
  const getWaitlisterSubtitleText = () => {
    return i18n.language === 'zh' 
      ? "等候者" 
      : "BOBO waitlister";
  };

  // 获取邮箱提示文本
  const getEmailNoticeText = () => {
    return i18n.language === 'zh'
      ? "输入邮箱获得专属优惠"
      : "Enter your email for exclusive offers";
  };
  
  return (
    <section className="reservation-section">
      <div className="reservation-container">
        <h2 className="reservation-title">{getWaitlisterTitleText()}</h2>
        <div className="reservation-number">
          <span className="highlight">{subscriberCount}{getNumberSuffix()}</span>
        </div>
        <h3 className="reservation-subtitle">{getWaitlisterSubtitleText()}</h3>
        
        <form onSubmit={handleSubmit} className="reservation-form">
          <input 
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={getEmailNoticeText()}
            className="reservation-input"
            disabled={isSubmitting}
            required
          />
          <button 
            type="submit" 
            className="reservation-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Reserve'}
          </button>
        </form>
        
        {message && <p className="reservation-success">{message}</p>}
        {error && <p className="reservation-error">{error}</p>}
        
        <p className="reservation-notify">{getEmailNoticeText()}</p>
        
        <div className="reservation-images">
          <img src="/images/page18/1.png" alt="BOBO with star eyes" className="bobo-image" />
          <img src="/images/page18/2.png" alt="BOBO with heart eyes" className="bobo-image" />
          <img src="/images/page18/3.png" alt="BOBO with bow" className="bobo-image" />
        </div>
      </div>
    </section>
  );
};

export default ReservationSection; 